<template>
    <div>
        <!-- <h2 class="text-h5 primary--text text-capitalize mb-3">Remaining Samples</h2> -->
        <v-form @submit.prevent="getMaterial()" ref="form">
            <v-row class="mt-1">
                <v-col cols="3">
                    <v-autocomplete
                        v-model="employeeId"
                        :items="employees"
                        item-text="name"
                        item-value="id"
                        :label="$t('inputs.employees')"
                        outlined
                        hide-details="auto"
                        dense
                        @keypress.enter="getMaterial()"
                        @change="entityId = null; summary = []; getMaterial()"
                    />
                </v-col>

                <v-col cols="3">
                    <v-autocomplete
                        v-model="entityId"
                        :items="doctors"
                        item-text="name"
                        item-value="accountId"
                        :label="$t('inputs.doctor')"
                        outlined
                        hide-details="auto"
                        dense
                        @keypress.enter="getMaterial()"
                        @change="employeeId = null; summary= []; getMaterial()"
                    />
                </v-col>
                <v-col>
                    <v-btn 
                        type="submit" 
                        color="success" 
                        dense 
                        small
                        :disabled="!employeeId && !entityId"
                    >
                        {{ $t('search') }}
                    </v-btn>
                </v-col>
                <v-spacer />
                <!-- <v-col class="d-flex justify-end">
                    <v-btn
                        small
                        :to="{ name: 'journal-items'}"
                        color="grey white--text"
                    >
                        <v-icon small class="me-1"> mdi-arrow-left-circle</v-icon>
                        Back
                    </v-btn>
                </v-col> -->
                <v-col class="d-flex justify-end">
                    <v-btn
                        small
                        :to="$route.query.from === 'delivery' ? { name: 'journal-delivery-of-samples' } : { name: 'journal-items'}"
                        color="grey white--text"
                    >
                        <v-icon small class="me-1"> mdi-arrow-left-circle</v-icon>
                        {{ $t('back')}}
                    </v-btn>
                    <v-divider vertical class="mx-1" />
                    <v-btn
                        small
                        color="green lighten-1 white--text"
                        @click="ImportExcel"
                        class="mx-1"
                        :loading="loadingExcel"
                        :disabled="loadingExcel"
                    >
                        <v-icon> mdi-file-table-outline </v-icon>
                        {{ $t('export-excel') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <bee-handy-table
            :headers="employeeId ? headers : headersForEntity"
            :items="!loading ? summary : []"
            :items-per-page="20"
            :loading="loading"
            multi-sort
            loading-text="Loading... Please wait"
            class="elevation-3"
            dense
            zebra
            hide-default-footer
            :height="$vuetify.breakpoint.height - 100"
            pagination-on-scroll
        >
        </bee-handy-table>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import rules from '@/validation rules'
import accounts from '@/store/modules/accounts';

export default {
    data(){
        return {
            loadingExcel: false,
            employeeId: null,
            loading: true,
            rules,
            employees: [],
            summary: [],
            entityId: null,
            doctors: []
        }
    },

    mounted() {
        this.employeeId = this.userId
        var promises = [];
        if (this.$store.state.materials.materials.length === 0) {
            promises.push(this.$store.dispatch('materials/fetchAll'));
        }
        if (this.$route.query.supervisor && this.$store.state.supervisors.supervisors.length === 0) {
            promises.push(this.$store.dispatch('supervisors/fetchAll'));
        }

        Promise.all(promises).then(() => {
            this.$store.dispatch('accounts/fetchAllBrief', { type: 1, entityType: 1 }).then((data) => {
                this.doctors = data
            })
            this.$store.dispatch('accounts/fetchAllBrief', { type: 0 }).then((data) => {
                this.employees = data
            }).then(() => {
                this.getMaterial()
            })
        });
    },

    methods: {
        getMaterial () {
            this.loading = true
            const actionName = this.employeeId ? 'fetchRemaining' : 'fetchMaterialFromEntity'
            this.$store.dispatch(`materialTransactions/${actionName}`, { 
                accountId: !this.employeeId ? this.entityId : null,
                id: this.employeeId ? this.employeeId : null
            }).then((data) => {
                this.summary = data
            })
            .finally(() => {
                this.loading = false;
            });
        },
        dig(getterName, id, prop){
            var object = this[getterName](id);
            return object ? object[prop] : null;
        },

        getFullMaterialName(material) {
            if (material == null) return null;

            var details = [
                this.getMaterialFormById(material.materialFormId)?.name,
                material.dose,
                material.strength
            ];

            return `${material?.name} (${details.filter(c => c != null).join(' ')})`;
        },

        ImportExcel() {
            this.loadingExcel = true
            this.$store.dispatch('exporter/fetchTransactionSummaryExport', { id: this.employeeId }).finally(() => {
                this.loadingExcel = false
            })
        }
    },

    watch: {
        menuOfStartDate (val) {
            val && setTimeout(() => (this.activePickerStartDate = 'YEAR'))
        },

        menuOfEndDate (val) {
            val && setTimeout(() => (this.activePickerEndDate = 'YEAR'))
        },
    },

    computed:{
        ...mapGetters({
            getMaterialById: 'materials/getMaterialById',
            getMaterialFormById: 'materialForms/getMaterialFormById',
        }),

        ...mapState({
            // summary: state => state.materialTransactions.summary,
            materials: state => state.materials.materials,
            materialForms: state => state.materialForms.materialForms,
            userId: state => state.auth.userData.employeeId
        }),
        headersForEntity() {
            const headers = [
                {
                    text: this.$t('headers.material'),
                    value: 'materialId',
                    setValueExpr: val => this.materials.find(c => c.id === val)?.name || 'N/A',
                    align: 'start',
                    class:'primary--text',
                    cellClass:'primary--text'
                },
                { 
                    text: this.$t('headers.remaining'),
                    value: 'amount',
                    align: 'start',
                },
            ]
            return headers
        },
        headers() {
            const headers = [
                {
                    text: this.$t('headers.material'),
                    value: 'in',
                    setValueExpr: val => this.getFullMaterialName(this.getMaterialById(val.materialId)) || 'N/A',
                    align: 'start',
                    class:'primary--text',
                    cellClass:'primary--text'
                },
                { 
                    text: this.$t('headers.remaining'),
                    value: 'remaining.amount',
                    align: 'start',
                },
            ]
            return headers
            
//             [
//     {
//         "materialName": null,
//         "materialId": "383f41db-d0d2-40a8-59d7-08dc6ddeb9f8",
//         "amount": 5,
//         "sellPrice": null
//     }
// ]
        }
    },

}
</script>

<style>

</style>